<template>
<div class="text-container">
    <p style="color:black;">{{text}}</p>
    <progress id="progress-bar" v-if="showprogress" style="padding:5px;"></progress>
</div>
</template>

<script>
export default {
    name: "CenteredText",
    props: ['text', 'showprogress', 'blacktext'],

}
</script>

<style>
.text-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    color: white;
    position: absolute;
    z-index: 2;
    background-color: transparent;
}
</style>
